import { toastMessage } from '@kocsistem/oneframe-react-bundle';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { userId } from '../../../_helpers/useful-functions';
import { post, del } from '../../../core/client';
import { MESSAGE_TYPE } from '../../../core/constants';
import { setLocalStorageItem } from '../../../core/utility';
import KvkkModal from '../../../pages/home/KvkkModal';
import ImageCropper from '../../../pages/image-cropper';
import { useAppSelector } from '../../../store';
import { getProfileUserDataById } from '../../../store/features/profile/profileSlice';
import { getUserInfo } from '../../../store/features/user/usersSlice';

const ModalDialog = (props: any) => {
    const dispatch = useDispatch();
    const [photo, setPhoto] = useState<Array<any>>([]);
    const [cropPhoto, setCropPhoto] = useState<Array<any>>([]);
    const [openKvkkModal, setOpenKvkkModal] = useState<boolean>(null);
    const [imgUrl, setImageUrl] = useState<Array<any>>([]);
    const [pleaseSelectPhoto, setPleaseSelectPhoto] = useState<string | null>(null);
    const { words } = useAppSelector(state => state.localization);
    const { userInfo } = useAppSelector(state => state.users.info);

    const newImageUrl = [];

    useEffect(() => {
        if (props?.open) {
            dispatch(getUserInfo());
        }
    }, [props?.open]);

    useEffect(() => {
        if (photo.length < 1) return;
        const newImageUrl = [];
        photo.forEach(image => newImageUrl.push(URL.createObjectURL(image)));
        setImageUrl(newImageUrl);
    }, [photo]);

    useEffect(() => {
        if (userInfo?.userChangePhoto) {
            newImageUrl.push(userInfo?.photo);
            setImageUrl(newImageUrl);
        }
    }, [userInfo?.photo]);

    const handleClose = () => {
        props?.setOpen(false);
    };

    const handleUpdatePhoto = e => {
        setPleaseSelectPhoto(null);
        const files = e.target.files;
        const validFiles = [];

        for (let i = 0; i < files.length; i++) {
            if (files[i].type.startsWith('image/')) {
                validFiles.push(files[i]);
            } else {
                toastMessage({
                    messageType: MESSAGE_TYPE.WARNING,
                    message: words && words['WEB.invalidFileType'],
                    position: 'topRight',
                    icon: 'flaticon-warning-sign',
                    timeout: 5000,
                });
            }
        }

        setPhoto(validFiles);
    };

    const handleSubmitImg = async () => {
        const endpoint = `/users/change-user-photo`;
        const formData = new FormData();
        if (cropPhoto.length > 0 || photo.length > 0) {
            formData.append('file', cropPhoto.length > 0 ? cropPhoto[0] : photo[0]);
        } else {
            setPleaseSelectPhoto(words && words['WEB.pleaseSelectPhoto']);
            return;
        }

        await post<any>(endpoint, formData, '').then((res: any) => {
            if (res?.isSuccessful) {
                props?.setOpen(false);
                setCropPhoto([]);
                dispatch(getProfileUserDataById(userId));
                toastMessage({
                    messageType: MESSAGE_TYPE.SUCCESS,
                    message: words && words['WEB.saveProfileSuccessfully'],
                    position: 'topRight',
                    icon: 'flaticon-like',
                    timeout: 5000,
                });
            } else {
                toastMessage({
                    messageType: MESSAGE_TYPE.WARNING,
                    message: res?.error?.message,
                    position: 'topRight',
                    icon: 'flaticon-warning-sign',
                    timeout: 6000,
                });
                setLocalStorageItem('APPROVE_KVKK', true);
                setOpenKvkkModal(true);
            }
        });
    };

    const handleDeletePhoto = async () => {
        await del(`users/delete-user-photo`, '').then((res: any) => {
            if (res?.data?.isSuccessful) {
                setPhoto([]);
                setCropPhoto([]);
                setImageUrl([]);
                dispatch(getProfileUserDataById(userId));
                props?.setOpen(false);
                toastMessage({
                    messageType: MESSAGE_TYPE.SUCCESS,
                    message: words && words['WEB.saveProfileSuccessfully'],
                    position: 'topRight',
                    icon: 'flaticon-like',
                    timeout: 5000,
                });
            } else {
                toastMessage({
                    messageType: MESSAGE_TYPE.WARNING,
                    message: res?.error?.message,
                    position: 'topRight',
                    icon: 'flaticon-warning-sign',
                    timeout: 6000,
                });
                setLocalStorageItem('APPROVE_KVKK', true);
                setOpenKvkkModal(true);
            }
        });
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-01"
            open={props?.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}>
            <Fade in={props?.open}>
                <>
                    <KvkkModal setOpenKvkkModal={setOpenKvkkModal} openKvkkModal={openKvkkModal} />
                    <div className="modal-02">
                        <div className="modal-header-01">
                            <span className="c-item-01">{words && words['WEB.changeProfilePhoto']}</span>
                            <CloseIcon onClick={handleClose} className="c-item-02" />
                        </div>

                        {imgUrl.length !== 0 && (
                            <div className="modal-button-wrap">
                                <input
                                    className="c-input"
                                    onChange={handleUpdatePhoto}
                                    accept=".png, .jpg, .jpeg"
                                    id="change-photo"
                                    type="file"
                                />
                                <label htmlFor="change-photo">
                                    <div className="button-03"> {words && words['WEB.newPhotoEdit']}</div>
                                </label>

                                <button onClick={handleDeletePhoto} className="button-03 delete">
                                    <svg width="17" height="18" viewBox="0 0 17 18" fill="#f56565" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.29032 16.3125C1.29032 16.7601 1.47093 17.1893 1.79242 17.5057C2.11391 17.8222 2.54995 18 3.0046 18H13.2903C13.745 18 14.181 17.8222 14.5025 17.5057C14.824 17.1893 15.0046 16.7601 15.0046 16.3125V4.5H1.29032V16.3125ZM11.0046 7.3125C11.0046 7.16332 11.0648 7.02025 11.172 6.91476C11.2791 6.80927 11.4245 6.75 11.576 6.75C11.7276 6.75 11.8729 6.80927 11.9801 6.91476C12.0873 7.02025 12.1475 7.16332 12.1475 7.3125V15.1875C12.1475 15.3367 12.0873 15.4798 11.9801 15.5852C11.8729 15.6907 11.7276 15.75 11.576 15.75C11.4245 15.75 11.2791 15.6907 11.172 15.5852C11.0648 15.4798 11.0046 15.3367 11.0046 15.1875V7.3125ZM7.57603 7.3125C7.57603 7.16332 7.63624 7.02025 7.7434 6.91476C7.85056 6.80927 7.99591 6.75 8.14746 6.75C8.29901 6.75 8.44436 6.80927 8.55152 6.91476C8.65869 7.02025 8.71889 7.16332 8.71889 7.3125V15.1875C8.71889 15.3367 8.65869 15.4798 8.55152 15.5852C8.44436 15.6907 8.29901 15.75 8.14746 15.75C7.99591 15.75 7.85056 15.6907 7.7434 15.5852C7.63624 15.4798 7.57603 15.3367 7.57603 15.1875V7.3125ZM4.14746 7.3125C4.14746 7.16332 4.20766 7.02025 4.31483 6.91476C4.42199 6.80927 4.56734 6.75 4.71889 6.75C4.87044 6.75 5.01579 6.80927 5.12295 6.91476C5.23011 7.02025 5.29032 7.16332 5.29032 7.3125V15.1875C5.29032 15.3367 5.23011 15.4798 5.12295 15.5852C5.01579 15.6907 4.87044 15.75 4.71889 15.75C4.56734 15.75 4.42199 15.6907 4.31483 15.5852C4.20766 15.4798 4.14746 15.3367 4.14746 15.1875V7.3125ZM15.576 1.12501H11.2903L10.9546 0.467584C10.8835 0.327034 10.7739 0.208807 10.6383 0.126202C10.5026 0.0435979 10.3463 -0.000106452 10.1867 6.16384e-06H6.1046C5.94545 -0.000596081 5.78935 0.0429453 5.65418 0.125642C5.519 0.208338 5.41023 0.326845 5.34032 0.467584L5.0046 1.12501H0.71889C0.567337 1.12501 0.421992 1.18427 0.314829 1.28976C0.207665 1.39525 0.147461 1.53832 0.147461 1.68751L0.147461 2.81251C0.147461 2.96169 0.207665 3.10476 0.314829 3.21025C0.421992 3.31574 0.567337 3.37501 0.71889 3.37501H15.576C15.7276 3.37501 15.8729 3.31574 15.9801 3.21025C16.0873 3.10476 16.1475 2.96169 16.1475 2.81251V1.68751C16.1475 1.53832 16.0873 1.39525 15.9801 1.28976C15.8729 1.18427 15.7276 1.12501 15.576 1.12501Z"
                                            fill="#f56565"
                                        />
                                    </svg>
                                    {words && words['WEB.delete']}
                                </button>
                            </div>
                        )}

                        <div className="modal-content-01">
                            {pleaseSelectPhoto &&
                                <div className="c-item-03">
                                    <div className="c-item-03-C">
                                        <strong>{pleaseSelectPhoto}</strong>
                                    </div>
                                </div>
                            }
                            {imgUrl.length === 0 && (
                                <div className="c-item-01">
                                    <input
                                        className="c-input"
                                        onChange={handleUpdatePhoto}
                                        accept=".png, .jpg, .jpeg"
                                        id="contained-button-file"
                                        type="file"
                                    />
                                    <div className="c-item-01-A">
                                        <label htmlFor="contained-button-file">
                                            <svg
                                                className="c-unit-01"
                                                width="70"
                                                height="70"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M4 4H7L9 2H15L17 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z"
                                                    fill="#00A3FF"
                                                />
                                            </svg>
                                        </label>
                                        <span className="c-unit-02">{words && words['WEB.uploadPhoto']}</span>
                                    </div>
                                </div>
                            )}

                            {imgUrl.length > 0 &&
                                imgUrl.map((img, index) => (
                                    <ImageCropper onCrop={croppedImage => setCropPhoto([croppedImage])} key={'img' + index} img={img} />
                                ))}
                            <div className="c-item-03">
                                <svg
                                    className="c-item-03-A"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path d="M12 16V12" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 8H12.01" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span className="c-item-03-B">{words && words['WEB.changePhotoWarningTtext']}</span>
                            </div>
                        </div>
                        <div className="modal-footer-01">
                            <button onClick={handleClose} className="c-item-01">
                                {words && words['WEB.giveUp']}
                            </button>
                            <button onClick={handleSubmitImg} className="c-item-02">
                                {words && words['WEB.save']}
                            </button>
                            {/* {photo.length > 0 && (photo[0].name.includes('.png') || photo[0].name.includes('.jpg') || photo[0].name.includes('.jpeg')) && (
                            <a href="#!" onClick={handleSubmitImg} className="c-item-02">
                                {words && words['WEB.save']}
                            </a>
                        )} */}
                        </div>
                    </div>
                </>
            </Fade>
        </Modal>
    );
};

export default ModalDialog;
